import { Star, ArrowRight, Phone } from "lucide-react";

const HERO_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/09d13hs7_CB6E2A6F-FCEE-4658-A61B-27AB7C3FCEBF.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Aerial view of a striped lawn maintained by Rapid Response"
          className="h-full w-full object-cover object-center scale-105"
          loading="eager"
        />
        {/* Gradients */}
        <div className="absolute inset-0 bg-gradient-to-r from-[var(--rr-bg)] via-[var(--rr-bg)]/85 to-[var(--rr-bg)]/40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--rr-bg)]/70 via-transparent to-[var(--rr-bg)]" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-10 lg:px-12 pt-40 md:pt-44 pb-28">
        <div className="max-w-3xl">
          <p className="overline reveal" style={{ transitionDelay: "0ms" }}>
            Based in Collegeville, PA
          </p>

          <h1
            data-testid="hero-headline"
            className="reveal mt-6 font-display font-semibold text-white text-5xl sm:text-6xl lg:text-[80px] leading-[1.02] tracking-tighter"
            style={{ transitionDelay: "80ms" }}
          >
            One Company for{" "}
            <span className="text-[var(--rr-accent)]">all your outdoor services</span>
          </h1>

          <p
            className="reveal mt-7 max-w-2xl text-lg md:text-xl leading-relaxed text-[var(--rr-text-muted)]"
            style={{ transitionDelay: "160ms" }}
          >
            Sealcoating, Landscaping, Lawn Care, Land Clearing, Tree Service, Material Delivery, Snow Removal.
          </p>
          <p
            className="reveal mt-3 font-display text-sm md:text-base tracking-[0.22em] uppercase text-[var(--rr-accent)]"
            style={{ transitionDelay: "200ms" }}
          >
            Residential · Commercial · HOA's
          </p>

          <div
            className="reveal mt-10 flex items-center gap-4"
            style={{ transitionDelay: "300ms" }}
          >
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="h-4 w-4 fill-[var(--rr-accent)] text-[var(--rr-accent)]"
                />
              ))}
            </div>
            <span className="text-sm text-[var(--rr-text-muted)]">
              <span className="text-white font-semibold">5.0</span> · 11 verified
              Google reviews
            </span>
          </div>
        </div>
      </div>

      {/* Bottom data row */}
      <div className="absolute bottom-8 left-0 right-0 z-10">
        <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-6 text-white">
          {[
            ["4+", "Years on the job"],
            ["1,000+", "Properties served"],
            ["24 hr", "Quote turnaround"],
            ["24/7", "Snow response"],
          ].map(([k, v]) => (
            <div key={k} className="border-l border-white/15 pl-4">
              <div className="font-display text-2xl md:text-3xl font-semibold tracking-tight">
                {k}
              </div>
              <div className="text-xs uppercase tracking-[0.18em] text-[var(--rr-text-muted)] mt-1">
                {v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
